import { affiliateData } from "../data/AffiliateData"
import { apiURL } from "./URLs"

export function formatPhoneNumber(phoneNumber) {
  const digits = phoneNumber.replace(/^\+1|\D/g, '')

  if (digits.length === 10)
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  else
    return phoneNumber
}

export function getPartOfDay() {
  const hour = new Date().getHours()

  if(hour < 12) return 'Good Morning, '
  if(hour < 18) return 'Good Afternoon, '
  return 'Good Evening, '
}

export async function refreshAccessToken() {
  const refreshAccessTokenResponse = await fetch(`${apiURL}/api/refreshAccessToken`, {
    credentials: 'include'
  })
  const refreshAccessTokenData = await refreshAccessTokenResponse.json()
  if(refreshAccessTokenData.response.error) {
    localStorage.removeItem('affiliateAccessToken')
    return ''
  } else {
    localStorage.setItem('affiliateAccessToken', refreshAccessTokenData.response.accessToken)
    affiliateData.accessToken = refreshAccessTokenData.response.accessToken

    return refreshAccessTokenData.response.accessToken
  }
}

export function darkenColor(color, percentage) {
  const num = parseInt(color.slice(1), 16)
  const amt = Math.round(2.55 * percentage)
  const R = Math.max((num >> 16) - amt, 0)
  const G = Math.max(((num >> 8) & 0x00ff) - amt, 0)
  const B = Math.max((num & 0x0000ff) - amt, 0)

  const hex = (1 << 24 | (R << 16) | (G << 8) | B).toString(16).slice(1).toUpperCase()

  return `#${hex}`
}